import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { LocaleService } from './locale.service';
import { Subscription } from 'rxjs';

declare const google: any;

@Injectable({
    providedIn: 'root',
})
export class GoogleAuthService implements OnDestroy {
    private clientId =
        '338644586723-1pae1um1fjdovdk7h0b4odtkon48dn4v.apps.googleusercontent.com';
    private currentCallback: ((payload: any) => void) | null = null;
    private languageSubscription?: Subscription;
    private isInitialized = false;
    private initializedLocale: string | null = null;

    constructor(
        private ngZone: NgZone,
        private localeService: LocaleService
    ) {
        this.languageSubscription = this.localeService.getCurrentLocale$().subscribe(() => {
            if (this.currentCallback) {
                this.isInitialized = false;
                this.disableAutoSelect();
                setTimeout(() => {
                    if (this.currentCallback) {
                        this.init(this.currentCallback);
                    }
                }, 100);
            }
        });
    }

    ngOnDestroy() {
        if (this.languageSubscription) {
            this.languageSubscription.unsubscribe();
        }
    }

    init(onSuccess: (payload: any) => void) {
        this.currentCallback = onSuccess;

        const currentLang = this.localeService.getCurrentLocale();
        const locale = currentLang === 'vi' ? 'vi' : 'en';

        if (this.isInitialized && this.initializedLocale === locale) {
            return;
        }

        this.isInitialized = true;
        this.initializedLocale = locale;

        google.accounts.id.initialize({
            client_id: this.clientId,
            callback: (response: any) => {
                this.ngZone.run(() => this.currentCallback?.(response.credential));
            },
            auto_select: false,
            cancel_on_tap_outside: false,
            locale: locale,
            // FedCM mandatory since Aug 2025 (Google no longer honors the legacy opt-out) —
            // opt in explicitly so the library uses the supported FedCM path instead of the
            // deprecated fallback, which throws console NetworkErrors under mandatory FedCM.
            use_fedcm_for_prompt: true,
        });
    }

    renderButton(elementId: string) {
        const btn = document.getElementById('googleBtn');
        if (btn) {
            // Xóa nội dung cũ (bắt buộc)
            btn.innerHTML = '';

            const currentLang = this.localeService.getCurrentLocale();
            const locale = currentLang === 'vi' ? 'vi' : 'en';

            google.accounts.id.renderButton(btn, {
                theme: 'outline',
                size: 'large',
                width: 320,
                locale: locale,
                use_fedcm_for_button: true,
            });
        } else {
            // console.error('googleBtn not found!');
        }
    }

    promptOneTap() {
        google.accounts.id.prompt();
    }

    disableAutoSelect() {
        google.accounts.id.disableAutoSelect();
    }

    /**
     * Dismisses the visible Google One Tap prompt (e.g. when user signs in
     * via login modal instead). Safe to call even if prompt is not visible.
     */
    cancelOneTap(): void {
        try {
            if (typeof google !== 'undefined' && google?.accounts?.id?.cancel) {
                google.accounts.id.cancel();
            }
        } catch {
            // Ignore if SDK not ready or prompt not shown
        }
    }
}
